import React, { useEffect, useState, useRef } from "react";
import { Alert as MuiAlert, Grid, DialogActions, Button, CircularProgress } from "@mui/material";
import { spacing } from "@mui/system";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useDialog } from "../../../../contexts/DialogContext";
import useUser from "../../../../hooks/useUser";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";
import CustomDatePicker from "../../../../components/CustomDatePicker";
import ScheduleIcon from "@mui/icons-material/Schedule";
import moment from "moment";
import CustomTextField from "../../../../components/CustomTextField";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  expiryDate: Yup.string().required("Required"),
  comments: Yup.string().required("Required"),
});

const ChangeValidity = (props) => {
  const [expiration, setExpiration] = useState(new Date());
  const dispatch = useDispatch();
  const { getUser, changeValidity, isValidtySubmitting } = useUser();

  const { user } = props;
  const { t } = useTranslation();

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });
  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;
  const { unSetDialog } = useDialog();

  React.useEffect(() => {
    if (user && Object.keys(user).length != 0) {
      const initialValues = {
        expiryDate: user.expiration,
      };
      reset(initialValues);
      setExpiration(moment(user.expiration, "DD-MM-YYYY HH:mm:ss a").toDate());
    }
  }, [user]);

  const onSubmit = async (data) => {
    console.log(data, "kjskskks");
    try {
      const payload = {
        radUserId: user.radUserId,
        expiryDate: data.expiryDate,
        comments: data.comments,
      };
      await changeValidity(payload);
      dispatch(showSuccessSnackbar("Validity updated successfully"));
      unSetDialog("change_validity");
      getUser(user.radUserId);
    } catch (ex) {
      dispatch(showErrorSnackbar(ex.message));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <CustomDatePicker
                name="expiryDate"
                label={t("change_validity")}
                range={false}
                control={control}
                fields={validationSchema.fields}
                timePicker={true}
                format="DD-MM-YYYY HH:mm:ss A"
                hideSeconds={false}
                conversionFormat="YYYY-MM-DD HH:mm:ss A"
              />
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={6}>
              <CustomTextField
                label={t("comments")}
                name="comments"
                type="text"
                my={2}
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                fields={validationSchema.fields}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<ScheduleIcon />}
              endIcon={isValidtySubmitting ? <CircularProgress size={24} /> : null}
              disabled={isValidtySubmitting}
            >
              Change
            </Button>

            <Button variant="text" onClick={() => unSetDialog("change_validity")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default ChangeValidity;
